import { render, staticRenderFns } from "./PostbackDelete.vue?vue&type=template&id=2cef11b5&scoped=true"
import script from "./PostbackDelete.vue?vue&type=script&lang=js"
export * from "./PostbackDelete.vue?vue&type=script&lang=js"
import style0 from "./PostbackDelete.vue?vue&type=style&index=0&id=2cef11b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef11b5",
  null
  
)

export default component.exports